import React from "react";

import './styles.css'
import Translate from "../../../components/Translate";
import Tooltip from "../../general/Tooltip";

/*
 * Two elements, not one.
 *
 * The outer box is where the caller's own className and style land, and it is
 * what decides where the group sits on the page - several screens pass
 * justifyContent through it. The inner one is the track: the grey pill the tabs
 * ride in, which has to be exactly as wide as they are and so cannot also be
 * the element that stretches across the page.
 */
const Tabs = ({
                  tabs = [],
                  selectedTab,
                  onTabChange,
                  renderTab,
                  className = "",
                  variant = 'default', // underline, flat, segment
                  fluid = false,
                  countTone = 'default', // danger
                  fontSize,
                  style = {},
                  itemStyle = {},
                  activeItemStyle = {},
              }) => {

    const isStringType = typeof tabs[0] === 'string';

    return (
        <div
            className={`tabs-container ${className} ${variant} ${fluid ? 'fluid' : ''} count-${countTone}`}
            /*
             * fontSize arrives as a custom property rather than as a font-size
             * on this element: the size has to reach the tab buttons, and a
             * font-size here would be overridden by their own rule. Every
             * variant reads the property and falls back to the body size.
             */
            style={fontSize ? {...style, '--tabs-font-size': fontSize} : {...style}}
        >
            <div className="tabs-track">
                {tabs.map((tab) => {

                    const isActive = isStringType ? tab === selectedTab : tab.value === selectedTab;

                    const button = (
                        <button
                            className={`tab-item ${isActive ? "active" : ""} ${tab.disabled ? "disabled" : ""}`}
                            onClick={() => onTabChange(isStringType ? tab : tab.value)}
                            style={{...itemStyle, ...(isActive ? activeItemStyle : {})}}
                            disabled={tab.disabled}
                        >
                            {variant === 'underline' && !isStringType && tab.icon && (
                                <span className="tab-item__icon" aria-hidden="true">{tab.icon}</span>
                            )}
                            {/*
                              * The label is wrapped rather than left loose in the
                              * button. text-overflow only works on a block box
                              * with inline content, and the button is a flex
                              * container - so an ellipsis written on it clips the
                              * text and never draws the dots.
                              */}
                            <span className="tab-item__label">
                                {renderTab ? renderTab(tab, isActive) :
                                    <Translate text={tab.label ? tab.label : tab.value ? tab.value : tab}/>}
                            </span>

                            {/*
                              * Outside the label, not in it. The label is the
                              * part that gets cut with an ellipsis when the
                              * track runs out of room, and a count drawn inside
                              * it was the first thing to disappear - which is
                              * the one part of a tab that has to stay readable.
                              */}
                            {!isStringType && tab.count ? (
                                <span className="tab-count">{tab.count}</span>
                            ) : null}
                        </button>
                    );

                    return !isStringType && tab.title ? (
                        <Tooltip key={tab.value} text={tab.title} needTranslate={false} asChild>
                            {button}
                        </Tooltip>
                    ) : React.cloneElement(button, {key: isStringType ? tab : tab.value});
                })}
            </div>
        </div>
    );
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components-new/ui/Tabs/index.jsx